import PositiveIcon from "../../../assets/icons/positive-test.svg";
import NegativeIcon from "../../../assets/icons/negative-test.svg";

const TestTrueFalse = ({ value }: { value: string }) => {
  const ButtonComponent = ({
    bgColor,
    img,
    title,
    btnValue,
  }: {
    bgColor: string;
    img: any;
    title: string;
    btnValue: string;
  }) => {
    return (
      <div
        className={`join-item flex items-center 
            ${
              value?.toString().toLowerCase() === btnValue
                ? bgColor
                : "bg-gray-200 text-gray-400"
            }
        select-none px-4 py-3 text-[15px] font-bold cursor-default`}
      >
        {value?.toString().toLowerCase() === btnValue && (
          <img src={img} alt={img} width={25} className="ml-1" />
        )}
        {title}
      </div>
    );
  };

  return (
    <div className="relative w-full max-w-[500px] lg:w-[500px] rounded-full mt-10 flex gap-1">
      <div className="absolute left-0 top-1/2 -translate-y-[50%] bg-gray-200 w-full h-2 rounded-full z-0"></div>
      <div className="join relative z-[1] mx-auto">
        <ButtonComponent
          bgColor="bg-pr_test_optimal"
          img={PositiveIcon}
          title="نتیجه مــثبت"
          btnValue="true"
        />

        <ButtonComponent
          bgColor="bg-pr_test_high"
          img={NegativeIcon}
          title="نتیجه مــنفی"
          btnValue="false"
        />
      </div>
    </div>
  );
};

export default TestTrueFalse;
